import { render } from "./PairToggle.vue?vue&type=template&id=3af8173c&scoped=true&ts=true"
import script from "./PairToggle.vue?vue&type=script&lang=ts"
export * from "./PairToggle.vue?vue&type=script&lang=ts"

import "./PairToggle.vue?vue&type=style&index=0&id=3af8173c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af8173c"]])

export default __exports__